import { createAction, props } from '@ngrx/store';
import { SystemEvent, SystemSignalrEvent } from './system-events.reducer';

export type SignalrConnectionAction = 'start' | 'reconnect';

export const newSystemEvent = createAction(
    '[System Event] New Event',
    props<{
        event: SystemEvent;
    }>(),
);

export const newSystemSignalrEvent = createAction(
    '[System Event] New SignalR Event',
    props<{
        event: SystemSignalrEvent;
    }>(),
);

export const registerSystemSignalrEvents = createAction(
    '[System Event] Register SignalR Events',
    props<{
        hubName: string;
        url: string;
        connectionAction: SignalrConnectionAction;
    }>(),
);

export const systemSignalrEventsRegistered = createAction(
    '[System Event] SignalR Events Registered',
    props<{
        hubName: string;
        url: string;
        connectionAction: SignalrConnectionAction;
    }>(),
);
